import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/** Scrolls to the element matching location.hash after navigation. */
export const useHashScroll = (offsetMs = 80) => {
  const location = useLocation();

  useEffect(() => {
    if (!location.hash) return undefined;
    const id = decodeURIComponent(location.hash.slice(1));
    const timer = window.setTimeout(() => {
      const el = document.getElementById(id);
      if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }, offsetMs);
    return () => window.clearTimeout(timer);
  }, [location.pathname, location.hash, offsetMs]);
};
